import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_WORKFLOW_COMPONENT_OBSERVER, TYPE_DATASOURCE } from 'src/app/app.models';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../../workflow-components.service';
  
export interface BHQrCodeScannerModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
}
  
export class BHQrCodeScannerModel extends DynamicInputModel {
	@serializable() readonly type: string = 'bh_qr_code_scanner';
	componentMode: COMPONENT_MODE;
	constructor(config: BHQrCodeScannerModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
	}

	static initModel(_component: Model_WorkflowComponent): BHQrCodeScannerModel {
		const formModel = new BHQrCodeScannerModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
            additional: _component,
			relations: _component.RELATIONS
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		return {
			ID: 'bh-qr-code-scanner',
			CODE: CODE_WORKFLOW_COMPONENT.BLACK_HAWK_SCAN_QRCODE,
			ICON: 'qr-code-outline',
			LABEL: '[BLACK-HAWK] Lecteur QRCode',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
			]
		};
	}
}
  